// Edge Developer, LLC — site data
export const tickerMessages = [
  "NORTH MANKATO • MANKATO • SOUTHERN MINNESOTA",
  "NOW BOOKING SPRING 2026 PROJECTS",
  "LICENSED • BONDED • INSURED IN MINNESOTA",
  "OVER 1,000 HOMES COMPLETED",
];

export const navLinks = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Locations", to: "/locations" },
  { label: "Projects", to: "/projects" },
  { label: "Contact", to: "/contact" },
];

export const services = [
  {
    id: "01",
    title: "Full Home Renovation",
    tag: "FLAGSHIP",
    body: "Whole-home transformations from gut to finish. Structural, MEP, and interior with one accountable team.",
    image: "https://images.unsplash.com/photo-1543332164-6e82f355badc?w=1200&q=80",
  },
  {
    id: "02",
    title: "Kitchen Remodels",
    tag: "POPULAR",
    body: "Custom millwork, stone, appliances and lighting design built for daily life.",
    image: "https://images.unsplash.com/photo-1682888813913-e13f18692019?w=1200&q=80",
  },
  {
    id: "03",
    title: "Bathroom Remodels",
    tag: "SPA-GRADE",
    body: "Wet rooms, radiant heat, full marble — engineered to last decades.",
    image: "https://images.unsplash.com/photo-1596205250168-c3583813eea0?w=1200&q=80",
  },
  {
    id: "04",
    title: "Additions & Extensions",
    tag: "STRUCTURAL",
    body: "Permitted dormers, rear extensions, ADUs. Engineered with licensed structural partners.",
    image: "https://images.unsplash.com/photo-1628744876497-eb30460be9f6?w=1200&q=80",
  },
  {
    id: "05",
    title: "Historic Restoration",
    tag: "SPECIALTY",
    body: "Greater Mankato is full of beautiful century homes. We preserve the character and engineer it for the next 100 years.",
    image: "https://images.unsplash.com/photo-1518235506717-e1ed3306a89b?w=1200&q=80",
  },
  {
    id: "06",
    title: "New Construction",
    tag: "GROUND-UP",
    body: "From foundation to certificate of occupancy. Custom builds for single-family and townhomes.",
    image: "https://images.unsplash.com/photo-1724582586529-62622e50c0b3?w=1200&q=80",
  },
];

export const process = [
  { num: "01", title: "Discovery", body: "Goals, scope, budget and timeline mapped on a single page." },
  { num: "02", title: "Design", body: "In-house designers translate vision into buildable plans." },
  { num: "03", title: "Permits", body: "City of North Mankato + county filings and structural engineering coordinated for you." },
  { num: "04", title: "Build", body: "One dedicated crew. Daily updates. Weekly walkthroughs." },
  { num: "05", title: "Punch", body: "Zero-defect handover backed by Edge Developer's two-year guarantee." },
];

export const stats = [
  { label: "Homes Delivered", value: "748+" },
  { label: "Kitchens Built", value: "854" },
  { label: "Bathrooms", value: "916" },
  { label: "5-Star Reviews", value: "1,022" },
  { label: "Years in Business", value: "12" },
  { label: "Avg. Build Time", value: "14 wk" },
];

export const locations = [
  {
    slug: "north-mankato",
    name: "North Mankato",
    region: "MN",
    image: "https://images.unsplash.com/photo-1628744876497-eb30460be9f6?w=1400&q=80",
    coverage: "North Mankato, Mankato, St. Peter, Eagle Lake, Lake Crystal, Madison Lake, and the greater southern Minnesota region",
    address: "743 Centre, North Mankato, MN 56003",
    phone: "(507) 351-8787",
  },
];

export const projects = [
  {
    slug: "lake-crystal-lakeside",
    location: "Lake Crystal",
    title: "Lakeside Retreat",
    subtitle: "Open-water living",
    year: "2025",
    type: "Full Renovation",
    sqft: "3,400",
    image: "https://images.pexels.com/photos/30699851/pexels-photo-30699851.jpeg?w=1600",
  },
  {
    slug: "north-mankato-kitchen",
    location: "North Mankato",
    title: "Centre Street Kitchen",
    subtitle: "Light, oak, and quartz",
    year: "2025",
    type: "Kitchen + Living",
    sqft: "1,100",
    image: "https://images.unsplash.com/photo-1682888813913-e13f18692019?w=1600&q=80",
  },
  {
    slug: "mankato-historic",
    location: "Mankato",
    title: "Hilltop Heritage",
    subtitle: "1908 brick meets modern",
    year: "2024",
    type: "Gut Renovation",
    sqft: "2,100",
    image: "https://images.unsplash.com/photo-1596205250168-c3583813eea0?w=1600&q=80",
  },
  {
    slug: "st-peter-family",
    location: "St. Peter",
    title: "Family Forever Home",
    subtitle: "Built for a growing family",
    year: "2024",
    type: "New Construction",
    sqft: "5,200",
    image: "https://images.unsplash.com/photo-1628744876497-eb30460be9f6?w=1600&q=80",
  },
  {
    slug: "eagle-lake-craftsman",
    location: "Eagle Lake",
    title: "Eagle Lake Craftsman",
    subtitle: "Hand-built joinery throughout",
    year: "2024",
    type: "Full Build-out",
    sqft: "4,600",
    image: "https://images.unsplash.com/photo-1681949103006-70066fb25dfe?w=1600&q=80",
  },
  {
    slug: "madison-lake-cottage",
    location: "Madison Lake",
    title: "Madison Lake Cottage",
    subtitle: "Four-season reimagined",
    year: "2023",
    type: "Addition + Reno",
    sqft: "6,800",
    image: "https://images.unsplash.com/photo-1576595580361-90a855b84b20?w=1600&q=80",
  },
];

export const reviews = [
  { name: "Frank L.", initial: "F", time: "a month ago", color: "#3aa55c", rating: 5,
    text: "From my first contact to the punch list, my experience with Edge Developer was a pleasant one. They turned our 1920s Mankato kitchen into a stunning modern space." },
  { name: "Aaron I.", initial: "A", time: "2 months ago", color: "#C9573D", rating: 5,
    text: "For a custom home build in North Mankato, I shopped around. A neighbor told me about Edge Developer. They made the process effortless." },
  { name: "Lola P.", initial: "L", time: "2 months ago", color: "#d97b8a", rating: 5,
    text: "Love Edge Developer. Used them three times for my rental properties around Mankato. Always quick. The team is professional." },
  { name: "Satya C.", initial: "S", time: "2 months ago", color: "#3fb7c6", rating: 5,
    text: "I partnered with Edge Developer for a full gut renovation of our St. Peter home, and the experience was exceptional. Their workmanship is best in class." },
  { name: "João V.", initial: "J", time: "2 months ago", color: "#7b6cc4", rating: 5,
    text: "Second time using them and Edge Developer is still the real deal. My realtor suggested them years ago for a small kitchen fix-up, and just recently I needed a bigger bathroom remodel done fast." },
  { name: "Priya M.", initial: "P", time: "3 months ago", color: "#c97c3d", rating: 5,
    text: "Edge Developer renovated our Eagle Lake home from top to bottom. Communication through EdgeBuild kept us totally in the loop. Highly recommend." },
];

export const licenses = [
  { state: "Minnesota Building Contractor", number: "BC-789432" },
  { state: "Lead-Safe Renovator (MN PCA)", number: "LSR-4451" },
  { state: "EPA Lead-Safe Firm", number: "NAT-F148329-2" },
  { state: "Nicollet County", number: "NC-2024-118" },
  { state: "Blue Earth County", number: "BE-2024-237" },
];

export const aboutPillars = [
  { num: "01", title: "One Team, Cradle to Keys", body: "No subbing your project out to a stranger. Your designer, project manager, and crew are all on payroll." },
  { num: "02", title: "Real-Time Transparency", body: "Daily photo logs. Live budget. Weekly schedule. You see everything we see." },
  { num: "03", title: "Engineered to Last", body: "Construction-grade materials, real structural detailing, and a two-year workmanship guarantee." },
  { num: "04", title: "Licensed In Minnesota", body: "Minnesota Building Contractor license, lead-safe certified, bonded and insured. We file the paperwork." },
];
